import { StyleSheet, TouchableOpacity, View } from "react-native";
import React from "react";
import CloseIcon from "../../assets/images/utils/CloseIcon";
import CachedImage from "./CachedImage";

const AnnouncementBanner = ({
  close,
  bannerSource,
}: {
  close: () => void;
  bannerSource: string;
}) => {
  const bannerSourceArr = bannerSource.split("/");

  return (
    <View style={styles.root}>
      <TouchableOpacity style={styles.closeBtn} onPress={close}>
        <CloseIcon />
      </TouchableOpacity>
      <CachedImage
        cacheKey={bannerSourceArr[bannerSourceArr.length - 1]}
        source={{ uri: bannerSource }}
        style={styles.image}
      />
    </View>
  );
};

export default AnnouncementBanner;

const styles = StyleSheet.create({
  root: {
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
  },
  image: {
    width: "90%",
    marginHorizontal: "5%",
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "#ddd",
    height: "70%",
    marginTop: 5,
  },
  closeBtn: {
    backgroundColor: "#fff",
    padding: 5,
    borderRadius: 9,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,

    elevation: 5,
  },
});
